import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Section, Cell, Text, Button } from '@telegram-apps/telegram-ui';
import { useTelegram } from '../hooks/useTelegram';

export function CompanyInfoPage() {
  const navigate = useNavigate();
  const { setBackButtonVisible } = useTelegram();

  useEffect(() => {
    setBackButtonVisible(true, () => navigate(-1));
    return () => setBackButtonVisible(false);
  }, [setBackButtonVisible, navigate]);

  return (
    <div style={{ padding: '16px' }}>
      <Text weight="1" style={{ fontSize: '24px', marginBottom: '16px' }}>
        О компании
      </Text>

      <Section header="СТОТЕК">
        <Cell subtitle="Специализация" multiline>
          Консалтинг, внедрение и сопровождение 1С и Битрикс24. Разработка, автоматизация бизнес-процессов.
        </Cell>
      </Section>

      <Section header="Контакты">
        <Cell
          subtitle="Телефон"
          onClick={() => window.open('tel:+78001234567')}
        >
          +7 (800) 123-45-67
        </Cell>
        <Cell
          subtitle="Email"
          onClick={() => window.open('mailto:info@ctotek.ru')}
        >
          info@ctotek.ru
        </Cell>
        <Cell subtitle="Адрес" multiline>
          г. Самара, ул. Примерная, д. 1
        </Cell>
      </Section>

      <Section header="Услуги">
        <Cell multiline>Внедрение 1С:Предприятие</Cell>
        <Cell multiline>Доработка и интеграция 1С</Cell>
        <Cell multiline>Внедрение Битрикс24</Cell>
        <Cell multiline>Техническая поддержка ИТС</Cell>
        <Cell multiline>Автоматизация бизнес-процессов</Cell>
      </Section>

      <div style={{ padding: '16px 0' }}>
        <Button
          size="l"
          stretched
          mode="outline"
          onClick={() => navigate('/callback')}
        >
          Запросить обратный звонок
        </Button>
      </div>
    </div>
  );
}
